import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface ReportGroupCardProps {
  title: string;
  description: string;
  icon: SvgIconComponent;
  color: string;
  onClick: () => void;
}

const ReportGroupCard: React.FC<ReportGroupCardProps> = ({
  title,
  description,
  icon: Icon,
  color,
  onClick
}) => {
  return (
    <Card
      sx={{
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #e2e8f0',
        borderLeft: `4px solid ${color}`,
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 25px rgba(0,0,0,0.12)',
        },
      }}
      onClick={onClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: '50%',
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon sx={{ color, fontSize: '2rem' }} />
          </Box>
          <Box flex={1}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: '#1e293b', mb: 0.5 }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              color="#64748b"
              sx={{ fontSize: '0.875rem' }}
            >
              {description}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ReportGroupCard;
